import React from "react";
import CheckPurpleSvg from "../../../../assets/images/checkPurple.svg";
import "./UploadButton.scss";

const UploadButton = ({ image, text, isCompleted, onClick, bgColor = "" }) => {
  return (
    <div
      className={`upload-container ${bgColor} ${
        isCompleted ? "completed" : null
      }`}
      onClick={onClick}
    >
      <div className="upload">
        <img src={image} alt="icono" />
        <p>{text}</p>
      </div>
      {isCompleted ? <img src={CheckPurpleSvg} alt="listo" /> : null}
    </div>
  );
};

export default UploadButton;
